import styled from "styled-components"
import Text from "../../atoms/Text"
import CheckRoundedIcon from '@mui/icons-material/CheckRounded';

const Conatiner = styled.label`
  input {
    display: none;
  }
  display: flex;
  align-items: center;
  gap: 8px;
`
// checkbox custom을 위한 div
const CustomCheckBox = styled.div`
  width: 24px;
  height: 24px;
  border: 1px solid ${(props) => props.theme.colors.secondary};
  background-color: ${({ checked, theme }) => (checked ?  theme.colors.secondary : theme.colors.neutral[100])};
  border-radius: 4px;
  color: ${(props) => props.theme.colors.neutral[100]};
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
`
const CheckIcon = styled(CheckRoundedIcon)`
  color: ${(props) => props.theme.colors.neutral[100]};
`
const LabeldCheckbox = ({label, checked, onChange}) => {
  return (
    <Conatiner>
      <input type="checkbox" checked={checked} onChange={onChange}/>
      <CustomCheckBox checked={checked} aria-checked={checked}>
          {checked && <CheckIcon sx={{ fontSize: 20 }}/>} 
      </CustomCheckBox>
      <Text
        variant="body2"
        weight="regular">
        {label}
      </Text>
    </Conatiner>
  )
}

export default LabeldCheckbox
